export const CURRENCIES: {[code: string]: string} = {
  "RUB": "₽",
  "UAH": "₴",
  "KZT": "₸",
}